import { useSeoMeta } from '#imports';

export function useRobots(
    robots: {
        nofollow?: boolean | (() => boolean);
        noindex?: boolean | (() => boolean);
    } = { nofollow: false, noindex: false }
) {
    const env = useRunEnv();
    const { isIos, isAndroid } = useDevice();
    if (env !== 'prod' || isAndroid.value || isIos.value) {
        useSeoMeta({
            robots: 'noindex, nofollow',
        });
    } else if (
        typeof robots.nofollow !== 'function' &&
        typeof robots.noindex !== 'function'
    ) {
        useSeoMeta({
            robots: `${robots.noindex ? 'noindex' : 'index'}, ${robots.nofollow ? 'nofollow' : 'follow'}`,
        });
    } else {
        // at least one of them is function
        const getterFunc = () => {
            const nofollowCondition =
                typeof robots.nofollow === 'function'
                    ? robots.nofollow()
                    : !!robots.nofollow;
            const noindexCondition =
                typeof robots.noindex === 'function'
                    ? robots.noindex()
                    : !!robots.noindex;
            return `${noindexCondition ? 'noindex' : 'index'}, ${nofollowCondition ? 'nofollow' : 'follow'}`;
        };
        useSeoMeta({
            robots: getterFunc,
        });
    }
}
